import { take, put } from 'redux-saga/effects';

import { LOGIN } from 'modules/auth/constants/actionTypes';
import { setPreferredLanguage } from '../actions';

export function *setLanguageOnLogin() {
    while(true) {
        yield take(LOGIN.REQUEST);
        const {sessionData:{lang}} = yield take(LOGIN.SUCCESS);
        yield put(setPreferredLanguage(lang));
    }
}

